module.exports = __webpack_public_path__ + "static/image/service/m/mart@3x.jpg?6cefcf39";